import React from 'react'

import { LogoStyles } from './styles'

const StvLogo = () => (
  <a className="StvLogo" href="/">
    STV Homepage
    <style jsx>{LogoStyles}</style>
  </a>
)

export default StvLogo
